import React from "react";
export default (({
  styles = {},
  ...props
}) => <svg xmlns="http://www.w3.org/2000/svg" width="19" height="19" viewBox="0 0 32 32" {...props}><path d="M7.219 5.781L16 14.562l8.781-8.781 1.438 1.438L17.438 16l8.781 8.781-1.438 1.438L16 17.438l-8.781 8.781-1.438-1.438L14.562 16 5.781 7.219z" /></svg>);